import { createAction } from "@reduxjs/toolkit";
import {
  cancelSubscriptionActionTypes,
  getListDonationsActionTypes,
  getListSubscriptionsActionTypes,
  getPaymentSubscriptionsActionTypes,
  getPaymentSubscriptionsPortionActionTypes,
  submitTransferActionTypes,
  resetPaymentsListActionTypes,
  cryptoTxActionTypes,
  getPromotionsActionTypes,
  addPayoutMethodActionTypes,
  sendDonationActionTypes,
  getListContentRequestsActionTypes,
  setDefaultCardActionTypes,
  getAgencyActionTypes,
  getAgencyUsersActionTypes,
} from "./actionTypes";

export const getPaymentSubscriptions = createAction(
  getPaymentSubscriptionsActionTypes.request,
);

export const getPaymentSubscriptionsSuccess = createAction(
  getPaymentSubscriptionsActionTypes.success,
  (payload) => ({ payload }),
);

export const getPaymentSubscriptionsFailure = createAction(
  getPaymentSubscriptionsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const getPortionPaymentSubscriptions = createAction(
  getPaymentSubscriptionsPortionActionTypes.request,
);

export const getPortionPaymentSubscriptionsSuccess = createAction(
  getPaymentSubscriptionsPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getPortionPaymentSubscriptionsFailure = createAction(
  getPaymentSubscriptionsPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getListSubscriptions = createAction(
  getListSubscriptionsActionTypes.request,
);

export const getListSubscriptionsSuccess = createAction(
  getListSubscriptionsActionTypes.success,
  (payload) => ({ payload }),
);

export const getListSubscriptionsFailure = createAction(
  getListSubscriptionsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const getListContentRequests = createAction(
  getListContentRequestsActionTypes.request,
);

export const getListContentRequestsSuccess = createAction(
  getListContentRequestsActionTypes.success,
  (payload) => ({ payload }),
);

export const getListContentRequestsFailure = createAction(
  getListContentRequestsActionTypes.failure,
  (error) => ({ payload: error }),
);

// todo: implement after backend update
export const submitTransfer = createAction(
  submitTransferActionTypes.request,
  (payload) => ({ payload }),
);

export const submitTransferSuccess = createAction(
  submitTransferActionTypes.success,
  (payload) => ({ payload }),
);

export const submitTransferFailure = createAction(
  submitTransferActionTypes.failure,
  (payload) => ({ payload }),
);

export const submitTransferReset = createAction(
  submitTransferActionTypes.reset,
);

export const getListDonations = createAction(
  getListDonationsActionTypes.request,
);

export const getListDonationsSuccess = createAction(
  getListDonationsActionTypes.success,
  (payload) => ({ payload }),
);

export const getListDonationsFailure = createAction(
  getListDonationsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const resetPaymentsList = createAction(
  resetPaymentsListActionTypes.reset,
  (payload) => ({ payload }),
);

export const cancelSubscription = createAction(
  cancelSubscriptionActionTypes.request,
);

export const cancelSubscriptionSuccess = createAction(
  cancelSubscriptionActionTypes.success,
  (payload) => ({ payload }),
);

export const cancelSubscriptionFailure = createAction(
  cancelSubscriptionActionTypes.failure,
  (error) => ({ payload: error }),
);
export const cancelSubscriptionReset = createAction(
  cancelSubscriptionActionTypes.reset,
);

export const cryptoTx = createAction(
  cryptoTxActionTypes.request,
  (payload) => ({ payload }),
);

export const getPromotions = createAction(getPromotionsActionTypes.request);
export const getPromotionsSuccess = createAction(
  getPromotionsActionTypes.success,
);
export const getPromotionsFailure = createAction(
  getPromotionsActionTypes.failure,
);
export const getAgency = createAction(getAgencyActionTypes.request);
export const getAgencySuccess = createAction(getAgencyActionTypes.success);
export const getAgencyFailure = createAction(getAgencyActionTypes.failure);
export const addPayoutMethod = createAction(addPayoutMethodActionTypes.request);
export const addPayoutMethodSuccess = createAction(
  addPayoutMethodActionTypes.success,
);
export const addPayoutMethodFailure = createAction(
  addPayoutMethodActionTypes.failure,
);

export const sendDonation = createAction(sendDonationActionTypes.request);
export const sendDonationSuccess = createAction(
  sendDonationActionTypes.success,
);
export const sendDonationFailure = createAction(
  sendDonationActionTypes.failure,
);
export const setDefaultCard = createAction(setDefaultCardActionTypes.request);
export const setDefaultCardSuccess = createAction(
  setDefaultCardActionTypes.success,
);
export const setDefaultCardFailure = createAction(
  setDefaultCardActionTypes.failure,
);
export const getAgencyUsers = createAction(getAgencyUsersActionTypes.request);
export const getAgencyUsersSuccess = createAction(
  getAgencyUsersActionTypes.success,
);
export const getAgencyUsersFailure = createAction(
  getAgencyUsersActionTypes.failure,
);
